// 用户API
import request from '@/utils/request'
/**
 * 获取隐私协议
 * @param {类型} params
 * @returns
 */
export const queryConfig = (params) => {
  return request({
    url: '/yslt-server-admin/api/v1/appIndex/getConfig',
    baseURL:
      'http://gateway.c67942520e73c4603b78ba4800005e3c4.cn-hangzhou.alicontainer.com',
    params
  })
}
/**
 * 获取分享签名
 */
export const queryShart = (params) => {
  return request({
    url: '/yslt-server-information/information/secondShare2',
    baseURL: 'http://121.40.31.114:9999/',
    params
  })
}
/**
 * 获取微信用户信息
 * @param {code} 用户code
 * @returns
 */
export const queryWxUserInfo = (code) => {
  return request({
    url: '/yslt-server-information/information/wechat-user-info',
    baseURL: 'http://121.40.31.114:9999/',
    params: {
      code
    }
  })
}
